import {
  TableRow,
  TableCell,
} from "styles/devices/deviceDetails.styles";
import { ParamSetPointCell } from "./params/ParamSetPointCell";
import { ParamConnectionCell } from "./params/ParamConnectionCell";

interface SensorStatusRowProps {
  name: string;
  currentValue: number | string | null;
  setPoint?: number | string;
  hideSetPoint?: boolean;
  isConnected: boolean;
  isEditing: boolean;
  pendingValue: number;
  pendingConnected: boolean;
  min: number;
  max: number;
  step: number;
  suffix?: string;
  disabled?: boolean;
  disabledMessage?: string;
  onValueChange: (value: number) => void;
  onConnectionToggle: () => void;
}

function SensorStatusRow({
  name,
  currentValue,
  setPoint,
  hideSetPoint = false,
  isConnected,
  isEditing,
  pendingValue,
  pendingConnected,
  min,
  max,
  step,
  suffix = "",
  disabled = false,
  disabledMessage = "",
  onValueChange,
  onConnectionToggle,
}: SensorStatusRowProps) {
  const slug = name.toLowerCase().replace(/\s+/g, "-");
  const formattedCurrentValue = currentValue === -9999 ? "X" : currentValue;

  return (
    <TableRow connected={isEditing ? pendingConnected : isConnected}>
      <TableCell>
        <strong>{name}</strong>
      </TableCell>
      <TableCell>{formattedCurrentValue}</TableCell>
      <TableCell>
        <ParamSetPointCell
          value={setPoint}
          pendingValue={pendingValue}
          isEditing={isEditing}
          min={min}
          max={max}
          step={step}
          suffix={suffix}
          disabled={disabled}
          disabledMessage={disabledMessage}
          inputId={`${slug}-setpoint`}
          onValueChange={onValueChange}
          hideValue={hideSetPoint}
        />
      </TableCell>
      <TableCell>
        <ParamConnectionCell
          isConnected={isConnected}
          pendingConnected={pendingConnected}
          isEditing={isEditing}
          disabled={disabled}
          disabledMessage={disabledMessage}
          switchId={`${slug}-connection`}
          onToggle={onConnectionToggle}
        />
      </TableCell>
    </TableRow>
  );
}

export default SensorStatusRow;
